import styled from 'styled-components';

export const Button = styled.button<{
  height?: number;
  paddingVertical?: number;
  fontSize?: string;
  borderRadios?: string;
  block?: boolean;
  transform?: boolean;
}>`
  cursor: pointer;
  height: ${(props) => (props.height ? `${props.height}px` : `38px`)};
  width: ${(props) => (props.block ? '100%' : 'auto')};

  border-radius: ${(props) => `${props.theme.borderRadius}px` || '4px'};
  padding: ${(props) =>
      props.paddingVertical ? `${props.paddingVertical}px` : '12px'}
    16px;
  font-weight: 900;
  box-shadow: none;
  background-color: ${(props) =>
    props.color === 'primary'
      ? (props) => props.theme.colors.primary
      : props.color === 'error'
      ? props.theme.colors.danger
      : (props) => props.theme.colors.primaryLight};
  color: ${(props) =>
    props.color === 'primary' || props.color === 'error'
      ? '#fff'
      : (props) => props.theme.colors.primary};
  outline: none;
  border: none;
  box-shadow: 0px 4px 4px rgba(50, 61, 109, 0.2);
  font-size: ${(props) => `${props.fontSize}px` || '13px'};
  text-transform: ${(props) => props.transform && 'uppercase'};

  &:hover {
    opacity: 0.85;
  }
  &:disabled {
    opacity: 0.4;
  }
  white-space: nowrap;
`;
